export const breakpoints = {
  bigMobile: "(min-width: 450px)",
  smallDesktop: "(min-width: 800px)",
  desktop: "(min-width: 950px)",
  bigDesktop: "(min-width: 1400px)",
};
